import { Box, Typography } from '@mui/material';

export const TableHeader = (props: {
  children: React.ReactNode,
}) => {
  return <Box sx={{ p: 5, maxWidth: '100%' }}>
    <Typography variant='textMD'
      fontWeight={600}
      sx={{ display: 'flex', alignItems: 'center' }}>
      {props.children}
    </Typography>
  </Box>;
};